<template>
    <b-card no-body class="mb-4">
        <template v-slot:header>
            <h5 class="mb-0">
                {{ $t("product_specs") }} ({{
                    product_files.length + variant_files.length
                }})
            </h5>
        </template>
        <b-card-body>
            <div v-if="!product_files.length && !variant_files.length">
                {{ $t("no_files_attached") }}
            </div>
            <file-items
                title="Product files"
                v-if="product_files.length"
                :files="product_files"
            ></file-items>
            <hr v-if="variant && variant_files.length"/>
            <file-items
                title="Variant files"
                v-if="variant && variant_files.length"
                :files="variant_files"
            ></file-items>
        </b-card-body>
    </b-card>
</template>

<script>
import axios from "axios";
import { mapGetters, mapState } from "vuex";
import { getFileTypeClass } from "../../../plugins/utilities";
import FileItems from "./FileItems";

export default {
  name: "SmartvaultFiles",
  components: { FileItems },
  data() {
    return {
      product_files: [],
      variant_files: [],
      filesLoading: false
    };
  },
  computed: {
    ...mapState("smartVaultProduct", {
      product: state => state.product,
      loading: state => state.loading
    }),
    ...mapGetters("smartVaultProduct", {
      variant: "getVariant"
    })
  },
  watch: {
    variant(n, o) {
      this.loadFiles();
    }
  },
  mounted() {
    this.loadFiles();
  },
  methods: {
    loadFiles() {
      const pp = axios
        .get(`/api/file-manager/base-product/${this.product.id}`)
        .then(r => {
          this.product_files = r.data.data;
        });

      let vp;
      if (this.variant) {
        this.variant_files = [];
        vp = axios
          .get(`/api/file-manager/variant/${this.variant.id}`)
          .then(r => {
            this.variant_files = r.data.data;
          });
      } else {
        vp = Promise.resolve();
      }

      Promise.all([pp, vp]).finally(() => {
        this.filesLoading = false;
      });
    }
  }
};
</script>
